export const FormName = 'VacationPlanForm';
